import { render, staticRenderFns } from "./public_challenges.vue?vue&type=template&id=caf80968&scoped=true"
import script from "./public_challenges.vue?vue&type=script&lang=js"
export * from "./public_challenges.vue?vue&type=script&lang=js"
import style0 from "./public_challenges.vue?vue&type=style&index=0&id=caf80968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf80968",
  null
  
)

export default component.exports